import Vue from 'vue'
import Vuex from 'vuex'
import VuexEasyFirestore from 'vuex-easy-firestore'
import { extractVuexModule, createProxy } from 'vuex-class-component'
import firebase from '@/firebase'

// Note: some of the sub modules uses vuex-class-component: https://github.com/michaelolof/vuex-class-component:
import { App } from './app/app'
import { AuthUser } from './authUser/authUser'
import clientsModule from './clients'
import clientSessionsModule from './clientSessions'
import clientModule from './client'
import studiesModule from './studies'
import studyCasesModule from './studyCases'

const easyFirestore = VuexEasyFirestore([
  clientsModule,
  clientModule,
  studiesModule,
  clientSessionsModule,
  studyCasesModule,
], {
  logging: process.env.myNewVar === 'DEVELOPMENT',
  FirebaseDependency: firebase,
  preventInitialDocInsertion: true,
})

Vue.use(Vuex)

export const store = new Vuex.Store({
  // modules defined with easy vuex-easy-firestore don't go in modules obj
  // they get included as modules in `const easyFirestore = VuexEasyFirestore([clients] ...`
  modules: {
    ...extractVuexModule(AuthUser),
    ...extractVuexModule(App),
  },
  plugins: [easyFirestore],
  state: {
  },
  mutations: {
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clearState({ commit }) {
      // console.log('clear data')
      this.dispatch('clients/closeDBChannel', { clearModule: true })
      this.dispatch('client/closeDBChannel', { clearModule: true })
      this.dispatch('clientSessions/closeDBChannel', { clearModule: true })
      this.dispatch('studies/closeDBChannel', { clearModule: true })
      this.dispatch('studyCases/closeDBChannel', { clearModule: true })
    },
  },
})

// Creating proxies, using https://github.com/michaelolof/vuex-class-component.
export const vxm = {
  authUser: createProxy(store, AuthUser),
  app: createProxy(store, App),
}
